import React from "react";
import { useApi } from "../hooks/useApi";

/**
 * Select RSA condivisa: legge l'elenco dal fabbisogno complessivo
 * (RSA configurate in phc_hrstdrsaconfigs).
 *
 * `allowDefault`: aggiunge in cima l'opzione pseudo-RSA "_DEFAULT" (standard
 * aziendale trasversale, si applica a tutte le RSA salvo override specifico
 * — vedi domain/aziendaliMerge.js). Usata solo dove ha senso editare quel
 * livello (es. AziendaliSection); altrove va omessa.
 */
export default function RsaSelect({ value, onChange, allowDefault = false }) {
  const { data, loading } = useApi("/fabbisogno");
  const rsaList = (data?.results || []).map((r) => r.rsa);

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      className="border border-gray-300 rounded px-3 py-1.5 text-sm bg-white"
      disabled={loading}
    >
      <option value="">— Seleziona RSA —</option>
      {allowDefault && (
        <option value="_DEFAULT">🏢 Default aziendale (tutte le RSA)</option>
      )}
      {rsaList.map((rsa) => (
        <option key={rsa} value={rsa}>
          {rsa}
        </option>
      ))}
    </select>
  );
}
